import axios from 'axios'
axios.defaults.withCredentials = true
function getQueryVariable(variable) {
  var query = window.location.search.substring(1);
  var vars = query.split("&");
  for (var i = 0; i < vars.length; i++) {
    var pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return null;
}

function getUrlVars(search) {
  if (!search) {
    return {}
  }
  if (search.startsWith('?')) {
    search = search.substr(1)
  }
  let reg = /([^=&\s]+)[=\s]*([^&\s]*)/g;
  let obj = {};
  while (reg.exec(search)) {
    obj[RegExp.$1] = RegExp.$2;
  }
  return obj;
}

function handleFeishuData(data) {
  if (!data.feishu_appid) {
    alert('未在商旅平台匹配到应用注册信息，请联系商旅负责人')
    return
  }
  let backUrl = encodeURIComponent(location.origin + '/v/vcommon/home')
  window.location.replace(`https://open.feishu.cn/open-apis/authen/v1/index?redirect_uri=${backUrl}&app_id=${data.feishu_appid}`)
}

async function login(params) {
  params.service = window.$ZConfig.getServerUrl()
  // 步骤一: 登录中心登录服务器
  let clientKey = params.KI4SO_CLIENT_EC
  if (!clientKey) {
    /** 临时调整 修复参数配置 */
    try{
      if(new URL(location.href).searchParams.get('_outParamKey')){
        params._outParamKey = new URL(location.href).searchParams.get('_outParamKey')
      }
    }catch(e){
      console.log(e)
    }
    let resPassport = await axios.get('/jsonp/login2.json', {
      baseURL: window.$ZConfig.getPassportUrl(),
      params,
      timeout: 20000,
      withCredentials: true
    })
    if (resPassport.data.code != '0') {
      return resPassport
    }
    clientKey = resPassport.data.clientKey
  }

  // 步骤二: 注入应用服务器
  let resClient = await axios.get('login.json?KI4SO_CLIENT_EC=' + clientKey,  {baseURL: window.$ZConfig.getServerUrl(), withCredentials: true})
  if (resClient.data.code != '0') {
    return resClient
  }
  let curServerUrl = window.$ZConfig.getServerUrl()
  // 步骤三: 重新加载配置信息
  let resConfig = await new Promise(function (resolve) {
    window.$ZConfig.reload(resolve)
  })
  // 服务域名与企业所在的域名不一致，无法提供后续服务
  if (curServerUrl != window.$ZConfig.getServerUrl()) {
    alert('当前登录用户所在的企业渠道异常，请联系系统管理员')
    return {code: '100010', msg: '该账号所在的企业信息异常'}
  }
  return resConfig
}


export default async function () {
  let query = getUrlVars(location.search)
  let res = {}
  let alp = query.alp 

  let KI4SO_CLIENT_EC = getQueryVariable('KI4SO_CLIENT_EC');
  if (alp) {
    let resAlpLogin = await login({loginType: 'alp', alp})
    res.reloadUrl = location.pathname + location.search.replace('alp=' + alp, '')
    if (resAlpLogin.code != '0') {
      let msg = '' 
      if (resAlpLogin.data && resAlpLogin.data.msg) {
        msg = resAlpLogin.data.msg
      }
      res.errorMsg = '登录信息异常:alp ' + msg
    }
  } else if (KI4SO_CLIENT_EC) {
    let resEcLogin = await login({KI4SO_CLIENT_EC})
    res.reloadUrl = location.pathname + location.search.replace('KI4SO_CLIENT_EC=' + KI4SO_CLIENT_EC, '')
    if (resEcLogin.code != '0') {
      res.errorMsg = '登录信息异常:ec'
    }
  } else {
    let params = {}
    let resIS = await axios.get('isLogin.json', {baseURL: window.$ZConfig.getServerUrl(), withCredentials: true, params})
    let data = resIS.data.data
    if (data.code != '0') {
      //飞书环境登录
      if (data.code == 9) {
        handleFeishuData(data)
        return Promise.reject()
      }
      let p = {}
      if (data.dd_corpId) {
        sessionStorage.setItem('dd_corpId', data.dd_corpId)
      }
    
      p.loginType = 'auto'
      // 自动登录
      let resAuto = await login(p)
      if (resAuto.code != '0') {
        res.reloadUrl = window.$ZConfig.getPassportUrl() + '/login'
      }
    }

  }
  return Promise.resolve(res)
}
